import { createContext as e, useContext as n } from "react";
import { noop as r } from "es-toolkit/function";
const s = {
  onClose: r,
  isSmallestDialog: !1,
  showXsDialogBorders: !1,
  showCloseButton: !0
}, t = e(s), a = t.Provider, c = () => {
  const o = n(t);
  if (!o)
    throw new Error("Dialog compound components cannot be rendered outside the Dialog component");
  return o;
};
export {
  a as DialogContextProvider,
  t as dialogContext,
  c as useDialogContext
};
//# sourceMappingURL=dialogContext.js.map
